import { useId } from 'react'
import { ModalOverlay } from './ui/ModalOverlay'
import { XCloseIcon, PhoneIcon, PrimaryButton } from './ui'

interface UpdatePolicyExternalLinkModalProps {
  fieldName: string
  onClose: () => void
}

export default function UpdatePolicyExternalLinkModal({ fieldName, onClose }: UpdatePolicyExternalLinkModalProps) {
  const titleId = useId()

  const handleGoToPolicy = () => {
    onClose()
  }

  return (
    <ModalOverlay
      open
      onClose={onClose}
      ariaLabelledBy={titleId}
      panelClassName="flex w-full max-w-[480px] flex-col overflow-clip rounded-2xl bg-background-primary shadow-xl"
    >
      <div className="relative flex w-full shrink-0 flex-col items-center">
        <div className="relative flex w-full shrink-0 flex-col items-start gap-[16px] px-[16px] pt-[20px]">
          <button
            type="button"
            onClick={onClose}
            className="absolute right-[12px] top-[12px] z-20 flex size-[44px] cursor-pointer items-center justify-center overflow-clip rounded-md p-[8px]"
            aria-label="Close"
          >
            <div className="relative size-6 shrink-0 overflow-clip text-text-tertiary-600">
              <XCloseIcon className="h-6 w-6" />
            </div>
          </button>

          <div className="relative flex size-12 shrink-0 items-center justify-center overflow-clip rounded-full bg-background-brand-secondary">
            <div className="relative size-6 shrink-0 overflow-clip text-brand-solid">
              <PhoneIcon className="h-6 w-6" />
            </div>
          </div>

          <div className="relative flex w-full shrink-0 flex-col items-start gap-[2px]">
            <h2
              id={titleId}
              className="relative w-full shrink-0 font-display text-display-xs font-semibold leading-[32px] text-text-primary-900"
            >
              Call us to continue
            </h2>
            <p className="relative w-full shrink-0 font-body text-sm font-regular leading-[24px] text-text-tertiary-600">
              To update your {fieldName}, please call our support team at{' '}
              <a href="tel:1300296296" className="text-brand-solid underline">
                1300 296 296
              </a>
              .
            </p>
          </div>
        </div>
        <div className="h-[20px] w-full shrink-0" />
      </div>

      <div className="relative flex w-full shrink-0 flex-col items-start pt-[24px]">
        <div className="relative flex w-full shrink-0 cursor-pointer flex-col items-start gap-[12px] px-[16px] pb-[16px]">
          <PrimaryButton onClick={handleGoToPolicy} fullWidth>
            Go to policy
          </PrimaryButton>
        </div>
      </div>
    </ModalOverlay>
  )
}
